var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#070A26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2258 20.6404C12.1575 20.7087 12.0467 20.7087 11.9784 20.6404L11.3596 20.0217C11.2913 19.9533 11.2913 19.8425 11.3596 19.7742L15.1338 16L11.3596 12.2258C11.2913 12.1575 11.2913 12.0467 11.3596 11.9783L11.9783 11.3596C12.0467 11.2913 12.1575 11.2913 12.2258 11.3596L16 15.1338L19.7742 11.3596C19.8426 11.2913 19.9534 11.2913 20.0217 11.3596L20.6404 11.9783C20.7088 12.0467 20.7088 12.1575 20.6404 12.2258L16.8662 16L20.6404 19.7742C20.7087 19.8425 20.7087 19.9533 20.6404 20.0217L20.0217 20.6404C19.9533 20.7087 19.8425 20.7087 19.7742 20.6404L16 16.8662L12.2258 20.6404Z",
    fill: "#070A26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/closeBtn.6511b6a9123ecdfd4d924db488559057.svg";
export { ForwardRef as ReactComponent };